export default (state, param) => {
  state.list = param
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/mutations/setContactForm.js